module.exports = __webpack_public_path__ + "static/media/resume.71697e24.png";